import React from "react";
import logo from "./images/logo.png"

const OldBrowserPage = () => (
  <div style={{ textAlign: 'center', padding: '10px' }}>
    <img src={logo} />
    <div style={{ padding: '10px' }}>Please use Google Chrome or Firefox to access this site.</div>
  </div>
);

export default OldBrowserPage


// WEBPACK FOOTER //
// ./src/OldBrowserPage.js